import { Outlet } from "react-router-dom";

export default function ProjsSAP(){
  return(
    <div>
      <Outlet />
    </div>
  );
}